import { isBrowser } from '../../config/environment'

/**
 * Video.js player interface with the methods we use - as we need more
 * symbols, feel free to add their types.
 */
export interface VideoJsPlayer {
  reportUserActivity?: () => void
  currentTime?: () => number
  paused?: () => boolean
  pause?: () => void
}

type WindowWithVideoJS = Window & {
  videojs?: {
    getAllPlayers?: () => VideoJsPlayer[]
  }
}

/**
 * Get the first video.js player instance from the page.
 *
 * Returns null if:
 * - Not in browser environment
 * - video.js is not loaded
 * - No players exist on the page
 */
export function getVideoPlayer (): VideoJsPlayer | null {
  if (!isBrowser()) return null

  const { videojs } = window as WindowWithVideoJS
  if (!videojs?.getAllPlayers) return null

  const players = videojs.getAllPlayers()
  if (!players || players.length === 0) return null

  return players[0] ?? null
}
